import { render } from "./SocialGraphSideBar.vue?vue&type=template&id=045ee992&scoped=true&ts=true"
import script from "./SocialGraphSideBar.vue?vue&type=script&lang=ts"
export * from "./SocialGraphSideBar.vue?vue&type=script&lang=ts"

import "./SocialGraphSideBar.vue?vue&type=style&index=0&id=045ee992&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045ee992"]])

export default __exports__